import { Metadata } from '../types/Metadata';

export const AppRefId = 'cpp-planning-app';

export const Blanks: Metadata<{
  name: string;
  description: string;
  isActive: boolean;
}> = {
  id: 'blanks',
  labels: [],
  props: {
    refId: 'blanks',
    name: '(Blanks)',
    description: '(blanks)',
    isActive: true
  },
  metadata: []
};

export enum ApprovalReason {
  Additional_KI_Leader = 1,
  Contextualization_Root_Author = 2,
  Primary_Research = 3,
  Secondary_Research = 4,
  Subject_Matter_Expert = 5,
  Vendor_Lead = 6,
  Other = 7,
  DisrupterReviewer = 8
}

export enum ApiResponseMessage {
  EndpointRequestTimedOut = 'Endpoint request timed out'
}
